import { render, staticRenderFns } from "./BasicLabel.vue?vue&type=template&id=da4bf0c0&scoped=true"
import script from "./BasicLabel.vue?vue&type=script&lang=js"
export * from "./BasicLabel.vue?vue&type=script&lang=js"
import style0 from "./BasicLabel.vue?vue&type=style&index=0&id=da4bf0c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4bf0c0",
  null
  
)

export default component.exports